import React from 'react';
import { REVIEW_CATALOG, RATING_DISPLAY, REVIEW_COUNT_DISPLAY, VERIFIED_ON } from '@/lib/reviews';
import './reviews.css';

export default function ReviewTrustBadge({ detailed=false, className='' }) {
  return <a className={`rv-badge ${className}`} href={`${REVIEW_CATALOG.pageUrl}#google-rating`} title={`Google profile checked ${VERIFIED_ON}. Overall Google rating, including all ratings.`}>
    <span className="rv-badge-main"><strong>{RATING_DISPLAY}</strong><span aria-hidden="true">★</span><span>{REVIEW_COUNT_DISPLAY} Google reviews</span></span>
    {detailed && <span className="rv-badge-date">Google profile checked {VERIFIED_ON}</span>}
  </a>;
}
